<template>
    <div class="widgetContainer">
        <div class="flexVertical">
            <span class="widgetTitle">{{getTitle()}}</span>
            <span class="widgetText">N = {{getCheckCount()}}</span>
        </div>
        <dx-circular-gauge v-if="dataFound" class="circulargauge" :value="getPercentage()">
            <dx-size :height="95" :width="210"/>
            <dx-value-indicator 
                type="textCloud"
                color="#999999">
                <dx-text :customizeText="getGaugeValueText">
                    <dx-font size="12px"/>
                </dx-text>
            </dx-value-indicator>
            <dx-range-container :ranges="ranges"/>
            <dx-geometry :start-angle="180" :end-angle="0" />
            <dx-scale :start-value="0" :end-value="100" :tick-interval="25">
                <dx-label :customizeText="getGaugeValueText">
                    <dx-font size="14px" color="rgba(51, 51, 51, 0.7)" family="'Helvetica Neue', 'Segoe UI', Helvetica, Verdana, sans-serif" :weight="700"/>
                </dx-label>
            </dx-scale>
            <dx-export :enabled="false" />
        </dx-circular-gauge>
        <div v-if="!dataFound" style="text-align: center;">No data for Total score</div>
        <div class="align-self-start">
            <button class="closeButton" v-on:click="$emit('close-widget')">
                <font-awesome-icon class="closeButtonIcon" icon="window-close" size="xs"/>
            </button>
        </div>
    </div>
</template>
<script>
  import DxCircularGauge, {DxAnimation, DxSize, DxValueIndicator, DxRangeContainer, DxGeometry, DxScale, DxText, DxLabel, DxTitle, DxFont, DxExport} from 'devextreme-vue/circular-gauge';
  
  export default {
    name: "WidgetTotalScore",

    mixins: [],

    components:{
        DxCircularGauge,
        DxAnimation,
        DxSize,
        DxValueIndicator,
        DxRangeContainer,
        DxGeometry,
        DxScale,
        DxText,
        DxLabel,
        DxTitle,
        DxFont,
        DxExport
    },

    props: {
        widgetdata: { type: Object, default: null},
        thresholds: null,
        percentageNumberOfDecimalPoints: {type: Number, default: 2},
    },

    watch: {
        thresholds: {
            immediate: true,
            handler(newVal, oldVal) {
                //console.log('WidgetTotalScore - watch - thresholds');
                this.mapThresholdsToComponentRanges();
            },
        },

        widgetdata: {
            immediate: true,
            handler(newVal, oldVal) {
                //console.log('WidgetTotalScore - watch - widgetdata');
                this.dataFound = newVal != null && newVal != undefined;
            },
        },

        percentageNumberOfDecimalPoints: {
            immediate: true,
            handler(newVal, oldVal) {
                //console.log('WidgetTotalScore - watch - percentageNumberOfDecimalPoints');
                this.internalPercentageNumberOfDecimalPoints = newVal;
            },
        }
    },

    created() {
        // console.log('WidgetTotalScore - created');
        // console.log('WidgetTotalScore - created - Data: ' + JSON.stringify(this.widgetdata));
    },

    mounted(){
        // console.log('WidgetTotalScore - mounted');
    },

    beforeDestroy() {
        // console.log('WidgetTotalScore - beforeDestroy');
    },

    data() {
      return {
        ranges: [
            { startValue: 0, endValue: 79, color: "#FF1500" },
            { startValue: 80, endValue: 89, color: "#FFD800" },
            { startValue: 90, endValue: 100, color: "#4CFF00" }],
        dataFound: false,
        internalPercentageNumberOfDecimalPoints: 2,
      }
    },

    methods: {

        mapThresholdsToComponentRanges() {
            // console.log('WidgetTotalScore - mapThresholdsToComponentRanges');
            if (this.thresholds != null && this.thresholds.length > 0) {
                this.ranges = [];
                for (let item of this.thresholds) {
                    this.ranges.push({startValue: item.Minimum, endValue: item.Maximum, color: item.Color});
                }
            }
        },

        getTitle() {
            // console.log('WidgetTotalScore - getTitle');
            return this.widgetdata && this.widgetdata.Title ? this.widgetdata.Title : "Total score";
        },

        getCheckCount() {
            // CheckCountTotal
            let retVal = 'N/A';
            if (this.widgetdata && this.widgetdata.CheckCountTotal) {
                retVal = this.widgetdata.CheckCountTotal;
            }
            return retVal;
        },
        
        getExport() {
            // console.log('WidgetTotalScore - getExport');
            return { enabled: false };
        },

        getPercentage() {
            let retVal = 0;
            if (this.widgetdata && this.widgetdata.Result) {
                const convertedValue = Number(this.widgetdata.Result);
                if (convertedValue !== NaN) {
                    retVal = convertedValue;
                }
            }
            // console.log("WidgetTotalScore - getPercentage: " + retVal);
            return retVal;
        },

        getGaugeValueText(arg) {
            // console.log("WidgetTotalScore - getGaugeValueText");
            // console.log(arg);

            let retVal = arg;
            if (arg && !Number.isNaN(arg.value)) {
                retVal = this.$n(arg.value, { minimumFractionDigits: this.internalPercentageNumberOfDecimalPoints, maximumFractionDigits: this.internalPercentageNumberOfDecimalPoints}) + '%';
            }
            // console.log("WidgetTotalScore - getGaugeValueText: " + retVal);
            return retVal;
        }
    },

    computed: {
    }
  }
</script>
<style>
    .flexVertical {
        display: flex;
        flex-direction: column;
    }
</style>